(() => {
  const LIMITS = {
    '48131613655205': { max: 5, label: 'sticker packs' },
    '48131613556901': { max: 25, label: 'flag decals' }
  };
  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let checkingCart = false;

  const numericId = (value) => String(value || '').split('/').pop();

  function variantForInput(input) {
    if (input.dataset.quantityVariantId) return numericId(input.dataset.quantityVariantId);
    const scope = input.closest('product-info, quick-add-modal, .product');
    const variantInput = scope && scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return numericId(variantInput && variantInput.value);
  }

  function addLimitNote(scope, rule) {
    if (!scope || scope.querySelector('.tsl-order-limit-note')) return;
    const note = document.createElement('p');
    note.className = 'tsl-order-limit-note caption';
    note.textContent = 'Maximum ' + rule.max + ' ' + rule.label + ' per order.';
    const quantityBlock = scope.querySelector('.product-form__quantity');
    if (quantityBlock) quantityBlock.appendChild(note);
  }

  function setProductLimit(input, rule) {
    const cartQuantity = parseInt(input.dataset.cartQuantity || '0', 10);
    const remaining = Math.max(rule.max - cartQuantity, 0);
    input.dataset.max = String(rule.max);
    input.max = String(remaining);
    input.min = remaining === 0 ? '0' : '1';
    if (parseInt(input.value || '1', 10) > remaining) input.value = String(remaining);
    if (remaining > 0 && parseInt(input.value || '0', 10) < 1) input.value = '1';

    const scope = input.closest('product-info, quick-add-modal, .product');
    addLimitNote(scope, rule);
    const submit = scope && scope.querySelector('form[action*="/cart/add"] [type="submit"]');
    if (!submit) return;

    if (remaining === 0) {
      if (!submit.dataset.tslLimitDisabled) {
        const text = submit.querySelector('span');
        submit.dataset.tslLimitDisabled = 'true';
        submit.dataset.tslOriginalText = text ? text.textContent : '';
      }
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      const text = submit.querySelector('span');
      if (text) text.textContent = 'Order limit reached';
    } else if (submit.dataset.tslLimitDisabled === 'true') {
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
      const text = submit.querySelector('span');
      if (text && submit.dataset.tslOriginalText) text.textContent = submit.dataset.tslOriginalText;
      delete submit.dataset.tslLimitDisabled;
    }
  }

  function setCartLimit(input, rule) {
    input.max = String(rule.max);
    const quantity = parseInt(input.value || '0', 10);
    const wrapper = input.closest('quantity-input');
    const plus = wrapper && wrapper.querySelector('button[name="plus"]');
    if (plus) plus.disabled = quantity >= rule.max;
  }

  function applyLimits(rootNode = document) {
    rootNode.querySelectorAll('input.quantity__input').forEach((input) => {
      const rule = LIMITS[variantForInput(input)];
      if (!rule) return;
      if (input.name === 'quantity') setProductLimit(input, rule);
      else setCartLimit(input, rule);
    });
  }

  window.fetch = async function(resource, options = {}) {
    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    const body = options && options.body;

    if (url.includes('/cart/add') && body instanceof FormData) {
      const variantId = numericId(body.get('id'));
      const rule = LIMITS[variantId];
      if (rule) {
        const requested = Math.max(parseInt(body.get('quantity') || '1', 10), 1);
        try {
          const response = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          const inCart = cart.items
            .filter((item) => numericId(item.variant_id) === variantId)
            .reduce((sum, item) => sum + item.quantity, 0);

          if (inCart + requested > rule.max) {
            const remaining = Math.max(rule.max - inCart, 0);
            const message = remaining
              ? 'You can add only ' + remaining + ' more. The maximum is ' + rule.max + ' ' + rule.label + ' per order.'
              : 'You have reached the maximum of ' + rule.max + ' ' + rule.label + ' per order.';
            return new Response(
              JSON.stringify({ status: 422, message, description: message, errors: message }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            );
          }
        } catch (error) {
          console.error('Unable to verify purchase limit.', error);
        }
      }
    }

    const response = await nativeFetch(resource, options);
    if (url.includes('/cart/')) setTimeout(() => applyLimits(), 0);
    return response;
  };

  async function reconcileCart() {
    if (checkingCart) return;
    checkingCart = true;
    try {
      const response = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      const updates = {};
      let corrected = false;

      cart.items.forEach((item) => {
        const variantId = numericId(item.variant_id);
        const rule = LIMITS[variantId];
        if (rule && item.quantity > rule.max) {
          updates[variantId] = rule.max;
          corrected = true;
        }
      });

      if (corrected) {
        await nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        window.location.reload();
      }
    } catch (error) {
      console.error('Unable to reconcile purchase limits.', error);
    } finally {
      checkingCart = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyLimits();
    reconcileCart();
    new MutationObserver(() => applyLimits()).observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input.quantity__input')) applyLimits();
  }, true);
})();